<template>
    <div v-route-title="'数据源管理'">
        <div class="database-view">
            <div class="header-view pr">
                <span class="huishouzhan_title">数据源管理</span>
                <div class="btn-layer">
                    <el-button @click="addRow" type="primary" icon="el-icon-circle-plus-outline">添加数据源</el-button>
                </div>
            </div>
            <el-form class="yq-search-form" inline :model="searchModel">
                <el-form-item>
                    <el-input v-model="searchModel.id" type="number" style="width: 90px;" placeholder="ID"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="searchModel.nameLike" style="width: 120px;" placeholder="数据源名称"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="searchModel.type" placeholder="数据源类型" clearable multiple style="width: 120px;">
                        <el-option v-for="item in types" :key="item.value" :value="item.value" :label="item.label"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="searchModel.indexNameLike" style="width: 120px;" placeholder="表名"></el-input>
                </el-form-item>
                <el-form-item>
                   <el-button type="primary" @click="search">搜索</el-button>
                </el-form-item>
            </el-form>
            <div v-if="data">
                <el-table class="yq-table" :data="data.content" style="width: 100%">
                    <el-table-column
                            label="序号"
                            type="index"
                            :index="indexMethod" width="60">
                    </el-table-column>
                    <el-table-column
                            prop="id"
                            label="ID" width="60">
                    </el-table-column>
                    <el-table-column
                            prop="name"
                            label="数据源名称">
                    </el-table-column>
                    <el-table-column
                            prop="type"
                            label="数据源类型" width="100">
                        <span slot-scope="scope">{{getTypeLabel(scope.row.type)}}</span>
                    </el-table-column>
                    <el-table-column
                            prop="indexName"
                            label="表名">
                    </el-table-column>
                    <el-table-column
                            label="创建时间" width="180">
                        <pretty-date-time slot-scope="scope" :value="scope.row.createdAt"/>
                    </el-table-column>
                    <el-table-column
                            label="创建用户" width="120">
                        <span slot-scope="scope">{{scope.row.creatorUser?scope.row.creatorUser.name:''}}</span>
                    </el-table-column>
                    <el-table-column
                            label="修改时间" width="180">
                        <pretty-date-time slot-scope="scope" :value="scope.row.editedAt"/>
                    </el-table-column>
                    <el-table-column
                            label="修改用户" width="120">
                        <span slot-scope="scope">{{scope.row.editorUser?scope.row.editorUser.name:''}}</span>
                    </el-table-column>
                    <el-table-column
                            label="操作" width="120">
                        <template slot-scope="scope">
                            <el-link icon="el-icon-edit" @click="editRow(scope.row)">修改</el-link>
                            <el-link icon="el-icon-delete" @click="deleteRow(scope.row)">删除</el-link>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <div class="clear"></div>
        <div class="magin10"></div>
        <div class="foot" v-if="data">
            <el-pagination
                    layout="prev, pager, next" background
                    :total="data.totalElements" :current-page="data.number+1"
                    @current-change="fetchData($event)">
            </el-pagination>
        </div>
        <el-dialog v-if="model" :title="model.id?'修改数据源':'添加数据源'" :visible.sync="dialogFormVisible" width="850px"
                   :close-on-click-modal="false">
            <el-form ref="form" :model="model" label-width="140px" :rules="rules">
                <el-form-item label="数据源名称" prop="name">
                    <el-input v-model="model.name"></el-input>
                </el-form-item>
                <el-form-item label="数据源类型" prop="type" v-if="!model.id">
                    <el-select v-model="model.type" style="width: 100%;">
                        <el-option v-for="item in types" :key="item.value" :value="item.value" :label="item.label"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="表名" prop="indexName">
                    <el-input v-model="model.indexName"></el-input>
                </el-form-item>
                <el-form-item label="启用推送" prop="enableSubscription">
                    <el-switch v-model="model.enableSubscription"></el-switch>
                </el-form-item>
                <el-form-item label="推送标题字段" prop="titleField" v-if="model.enableSubscription">
                    <el-input v-model="model.titleField"></el-input>
                </el-form-item>
                <el-form-item label="推送站点字段" prop="siteField" v-if="model.enableSubscription">
                    <el-input v-model="model.siteField"></el-input>
                </el-form-item>
                <el-form-item label="推送发布时间字段" prop="publishTimeField" v-if="model.enableSubscription">
                    <el-input v-model="model.publishTimeField"></el-input>
                </el-form-item>
                <el-form-item label="推送入库时间字段" prop="loadTimeField" v-if="model.enableSubscription">
                    <el-input v-model="model.loadTimeField"></el-input>
                </el-form-item>
                <el-form-item label="推送原文链接字段" prop="urlField" v-if="model.enableSubscription">
                    <el-input v-model="model.urlField"></el-input>
                </el-form-item>
            </el-form>
            <div v-for="(field,index) in model.fields" :key="index" class="yq-ds-field">
                <el-form ref="fieldForm" :model="field" :rules="fieldRules" inline size="mini">
                    <el-form-item prop="name">
                        <el-input v-model="field.name" placeholder="字段名" style="width: 100px;"></el-input>
                    </el-form-item>
                    <el-form-item prop="title">
                        <el-input v-model="field.title" placeholder="字段显示名" style="width: 100px;"></el-input>
                    </el-form-item>
                    <el-form-item prop="type">
                        <el-select v-model="field.type" placeholder="字段类型" style="width: 120px;">
                            <el-option v-for="item in fieldTypes" :key="item.value" :value="item.value" :label="item.label"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="nullable">
                        <el-select v-model="field.nullable" placeholder="是否可空" style="width: 110px;">
                            <el-option :value="true" label="可空"></el-option>
                            <el-option :value="false" label="不可空"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="multiple" v-if="field.type === 'KEYWORD'">
                        <el-select v-model="field.multiple" placeholder="是否多值" style="width: 110px;">
                            <el-option :value="true" label="多值"></el-option>
                            <el-option :value="false" label="单值"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="dictName" v-if="field.type === 'KEYWORD'">
                        <el-select v-model="field.dictName" placeholder="字典" style="width: 110px;" clearable>
                            <el-option v-for="item in dictTypes" :key="item" :value="item" :label="item"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="dateFormat" v-if="field.type === 'DATETIME' || field.type === 'DATE' || field.type === 'TIME'">
                        <el-input v-model="field.dateFormat" placeholder="日期格式" style="width: 100px;"></el-input>
                    </el-form-item>
                    <el-form-item prop="dateValueFormat" v-if="field.type === 'DATETIME' || field.type === 'DATE' || field.type === 'TIME'">
                        <el-input v-model="field.dateValueFormat" placeholder="日期存储格式" style="width: 100px;"></el-input>
                    </el-form-item>
                    <el-form-item prop="searchable" v-if="field.type !== 'HIGHLIGHT'">
                        <el-select v-model="field.searchable" placeholder="是否可检索" style="width: 110px;">
                            <el-option :value="true" label="可检索"></el-option>
                            <el-option :value="false" label="不可检索"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="aggregatable" v-if="field.type !== 'TEXT' && field.type !== 'HIGHLIGHT'">
                        <el-select v-model="field.aggregatable" placeholder="是否可统计" style="width: 110px;">
                            <el-option :value="true" label="可统计"></el-option>
                            <el-option :value="false" label="不可统计"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="sortable" v-if="field.type !== 'TEXT' && field.type !== 'HIGHLIGHT'">
                        <el-select v-model="field.sortable" placeholder="是否可排序" style="width: 110px;">
                            <el-option :value="true" label="可排序"></el-option>
                            <el-option :value="false" label="不可排序"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="supportWildcast" v-if="field.type === 'KEYWORD'">
                        <el-select v-model="field.supportWildcast" placeholder="是否支持模糊检索" style="width: 140px;">
                            <el-option :value="true" label="支持模糊检索"></el-option>
                            <el-option :value="false" label="不支持模糊检索"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="supportMultiValue" v-if="field.type === 'KEYWORD'">
                        <el-select v-model="field.supportMultiValue" placeholder="是否支持多值检索" style="width: 140px;">
                            <el-option :value="true" label="支持多值检索"></el-option>
                            <el-option :value="false" label="不支持多值检索"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="highlightName" v-if="field.type === 'HIGHLIGHT'">
                        <el-input v-model="field.highlightName" placeholder="高亮字段名" style="width: 100px;"></el-input>
                    </el-form-item>
                    <el-form-item prop="highlightFragmentSize" v-if="field.type === 'HIGHLIGHT'">
                        <el-input v-model.number="field.highlightFragmentSize" placeholder="高亮片段长度" style="width: 110px;"></el-input>
                    </el-form-item>
                    <el-form-item prop="highlightFragmentNum" v-if="field.type === 'HIGHLIGHT'">
                        <el-input v-model.number="field.highlightFragmentNum" placeholder="高亮片段数量" style="width: 110px;"></el-input>
                    </el-form-item>
                    <el-form-item prop="fallbackField" v-if="field.type === 'HIGHLIGHT'">
                        <el-input v-model="field.fallbackField" placeholder="高亮后备字段" style="width: 110px;"></el-input>
                    </el-form-item>
                    <el-form-item prop="displayWidth">
                        <el-input v-model.number="field.displayWidth" placeholder="显示宽度" style="width: 80px;"></el-input>
                    </el-form-item>
                    <el-form-item prop="displayGroup">
                        <el-select v-model="field.displayGroup" placeholder="显示分组" style="width: 100px;">
                            <el-option v-for="item in displayGroups" :key="item.value" :value="item.value" :label="item.label"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="displayType">
                        <el-select v-model="field.displayType" placeholder="显示类型" style="width: 100px;">
                            <el-option v-for="item in displayTypes" :key="item.value" :value="item.value" :label="item.label"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="displayInIndex">
                        <el-select v-model="field.displayInIndex" placeholder="首页是否显示" style="width: 120px;">
                            <el-option :value="true" label="首页显示"></el-option>
                            <el-option :value="false" label="首页不显示"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="seqNoInIndex" v-if="field.displayInIndex">
                        <el-input v-model.number="field.seqNoInIndex" placeholder="首页显示顺序" style="width: 110px;"></el-input>
                    </el-form-item>
                    <el-form-item prop="displayInList">
                        <el-select v-model="field.displayInList" placeholder="列表是否显示" style="width: 120px;">
                            <el-option :value="true" label="列表显示"></el-option>
                            <el-option :value="false" label="列表不显示"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="seqNoInList" v-if="field.displayInList">
                        <el-input v-model.number="field.seqNoInList" placeholder="列表显示顺序" style="width: 110px;"></el-input>
                    </el-form-item>
                    <el-form-item prop="displayInDetails">
                        <el-select v-model="field.displayInDetails" placeholder="细览是否显示" style="width: 120px;">
                            <el-option :value="true" label="细览显示"></el-option>
                            <el-option :value="false" label="细览不显示"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="seqNoInDetails" v-if="field.displayInDetails">
                        <el-input v-model.number="field.seqNoInDetails" placeholder="细览显示顺序" style="width: 110px;"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button-group>
                            <el-button icon="el-icon-top" @click="moveFieldUp(index)"></el-button>
                            <el-button icon="el-icon-bottom" @click="moveFieldDown(index)"></el-button>
                            <el-button icon="el-icon-delete" @click="deleteField(index)"></el-button>
                        </el-button-group>
                    </el-form-item>
                </el-form>
            </div>
            <div>
                <el-button @click="addField" size="mini">添加字段</el-button>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitForm">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import datasourceConfigService from '../service/datasource-config'
    import dictService from '../service/dict'

    const fieldTypes = [
        {value: "BOOLEAN", label: "布尔值"},
        {value: "DATE", label: "日期"},
        {value: "DATETIME", label: "日期时间"},
        {value: "TIME", label: "时间"},
        {value: "KEYWORD", label: "字符串"},
        {value: "TEXT", label: "全文"},
        {value: "LONG", label: "长整形"},
        {value: "INTEGER", label: "整形"},
        {value: "SHORT", label: "短整形"},
        {value: "DOUBLE", label: "双精度浮点数"},
        {value: "FLOAT", label: "单精度浮点数"},
        {value: "HIGHLIGHT", label: "高亮字段"},
    ]

    const displayGroups = [
        {value: 'TITLE', label: "标题"},
        {value: 'META', label: "元数据"},
        {value: 'CONTENT', label: "正文"}
    ]

    const displayTypes = [
        {value: 'DEFAULT', label: "默认"},
        {value: 'LINK', label: "链接"},
    ]

    export default {
        name: "ProjectAdmin",
        data() {
            const checkName = (rule, value, callback) => {
                if (value) {
                    datasourceConfigService.listDatasourceConfigs({name: value}).then(response => {
                        if (response.data.content.length > 0 && this.model.id !== response.data.content[0].id) {
                            callback(new Error('名称已被占用'))
                        } else {
                            callback();
                        }
                    }).catch(error => {
                        callback(new Error('校验出错'))
                        throw error
                    })
                } else {
                    callback()
                }
            }
            const checkFieldName = (rule, value, callback) => {
                if (value) {
                    const arr = this.model.fields.filter(field => field.name === value)
                    if(arr.length > 1){
                        callback(new Error('字段重名'))
                    }else{
                        callback()
                    }
                } else {
                    callback()
                }
            }
            const checkField = (rule, value, callback) => {
                if (value) {
                    const arr = this.model.fields.filter(field => field.name === value)
                    if(arr.length === 0){
                        callback(new Error('字段未定义'))
                    }else{
                        callback()
                    }
                } else {
                    callback()
                }
            }
            return {
                types: datasourceConfigService.getTypes(),
                data: null,
                dialogFormVisible: false,
                searchModel: {
                    id: null,
                    nameLike: null,
                    type: null,
                    indexNameLike: null
                },
                searchParams: {
                    id: null,
                    nameLike: null,
                    type: null,
                    indexNameLike: null
                },
                model: null,
                rules: {
                    name: [
                        {required: true, message: '请输入数据源名称', trigger: 'blur'},
                        {min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur'},
                        {validator: checkName, trigger: 'blur'}
                    ],
                    type: [
                        {required: true, message: '请选择数据源类型', trigger: 'blur'}
                    ],
                    indexName: [
                        {required: true, message: '请输入表名', trigger: 'blur'},
                        {min: 1, max: 100, message: '长度在 1 到 100 个字符', trigger: 'blur'}
                    ],
                    titleField: [
                        {required: true, message: '请输入推送标题字段', trigger: 'blur'},
                        {validator: checkField, trigger: 'blur'}
                    ],
                    siteField: [
                        {required: true, message: '请输入推送站点字段', trigger: 'blur'},
                        {validator: checkField, trigger: 'blur'}
                    ],
                    publishTimeField: [
                        {required: true, message: '请输入推送发布时间字段', trigger: 'blur'},
                        {validator: checkField, trigger: 'blur'}
                    ],
                    loadTimeField: [
                        {required: true, message: '请输入推送入库时间字段', trigger: 'blur'},
                        {validator: checkField, trigger: 'blur'}
                    ],
                    urlField: [
                        {required: true, message: '请输入推送原文链接字段', trigger: 'blur'},
                        {validator: checkField, trigger: 'blur'}
                    ]
                },
                fieldRules: {
                    name: [
                        {required: true, message: '请输入字段名', trigger: 'blur'},
                        {min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur'},
                        {validator: checkFieldName, trigger: 'blur'}
                    ],
                    title: [
                        {required: true, message: '请输入字段显示名', trigger: 'blur'},
                        {min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur'},
                    ],
                    type: [
                        {required: true, message: '请选择字段类型', trigger: 'blur'}
                    ],
                    nullable: [
                        {required: true, message: '请选择是否可空', trigger: 'blur'}
                    ],
                    multiple: [
                        {required: true, message: '请选择是否多值', trigger: 'blur'}
                    ],
                    dateFormat: [
                        {required: true, message: '请输入日期格式', trigger: 'blur'},
                        {min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur'}
                    ],
                    dateValueFormat: [
                        {required: true, message: '请输入日期存储格式', trigger: 'blur'},
                        {min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur'}
                    ],
                    searchable: [
                        {required: true, message: '请选择是否可检索', trigger: 'blur'}
                    ],
                    aggregatable: [
                        {required: true, message: '请选择是否可统计', trigger: 'blur'}
                    ],
                    sortable: [
                        {required: true, message: '请选择是否可排序', trigger: 'blur'}
                    ],
                    supportWildcast: [
                        {required: true, message: '请选择是否支持模糊检索', trigger: 'blur'}
                    ],
                    supportMultiValue: [
                        {required: true, message: '请选择是否支持多值检索', trigger: 'blur'}
                    ],
                    highlightName: [
                        {required: true, message: '请输入高亮字段名', trigger: 'blur'},
                        {min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur'},
                    ],
                    highlightFragmentSize: [
                        {required: true, message: '请输入高亮片段长度', trigger: 'blur'},
                        {type: 'integer', min: 0, max: 1000, message: '不超过1000的正整数', trigger: 'blur'}
                    ],
                    highlightFragmentNum: [
                        {required: true, message: '请输入高亮片段数量', trigger: 'blur'},
                        {type: 'integer', min: 0, max: 10, message: '不超过10的正整数', trigger: 'blur'}
                    ],
                    fallbackField: [
                        {min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur'},
                    ],
                    displayWidth: [
                        {required: true, message: '请输入显示宽度', trigger: 'blur'},
                        {type: 'integer', min: 1, max: 1000, message: '不超过1000的正整数', trigger: 'blur'}
                    ],
                    displayGroup: [
                        {required: true, message: '请选择显示分组', trigger: 'blur'}
                    ],
                    displayType: [
                        {required: true, message: '请选择显示类型', trigger: 'blur'}
                    ],
                    displayInIndex: [
                        {required: true, message: '请选择首页是否显示', trigger: 'blur'}
                    ],
                    seqNoInIndex: [
                        {required: true, message: '请输入首页显示顺序', trigger: 'blur'},
                        {type: 'integer', min: 0, max: 1000, message: '不超过1000的正整数', trigger: 'blur'}
                    ],
                    displayInList: [
                        {required: true, message: '请选择列表是否显示', trigger: 'blur'}
                    ],
                    seqNoInList: [
                        {required: true, message: '请输入列表显示顺序', trigger: 'blur'},
                        {type: 'integer', min: 0, max: 1000, message: '不超过1000的正整数', trigger: 'blur'}
                    ],
                    displayInDetails: [
                        {required: true, message: '请选择细览是否显示', trigger: 'blur'}
                    ],
                    seqNoInDetails: [
                        {required: true, message: '请输入细览显示顺序', trigger: 'blur'},
                        {type: 'integer', min: 0, max: 1000, message: '不超过1000的正整数', trigger: 'blur'}
                    ]
                },
                fieldTypes,
                displayGroups,
                displayTypes,
                dictTypes: []
            }
        },
        created() {
            this.fetchData(1)
            this.fetchDictTypes()
        },
        methods: {
            async fetchData(page) {
                const params = Object.assign({},this.searchParams,{page: page - 1, size: 10})
                const response = await datasourceConfigService.listDatasourceConfigs(params)
                this.data = response.data
            },
            async fetchDictTypes(){
                const response = await dictService.listAllDictTypes()
                this.dictTypes = response.data
            },
            indexMethod(index) {
                return this.data.number * this.data.size + index + 1
            },
            search(){
                this.searchParams = JSON.parse(JSON.stringify(this.searchModel))
                this.fetchData(1)
            },
            addRow() {
                this.model = {
                    name: null,
                    type: null,
                    indexName: null,
                    enableSubscription: false,
                    titleField: null,
                    siteField: null,
                    publishTimeField: null,
                    publishTimeSpan: null,
                    loadTimeField: null,
                    loadTimeDelay: null,
                    initLoadTimeSpan: null,
                    urlField: null,
                    fields: []
                }
                this.dialogFormVisible = true
            },
            editRow(row) {
                datasourceConfigService.getDatasourceConfig(row.id).then(response => {
                    if(response.data.fields){
                        response.data.fields = JSON.parse(response.data.fields)
                    } else {
                        response.data.fields = []
                    }
                    this.model = response.data
                    this.dialogFormVisible = true
                })
            },
            async submitForm() {
                const validatePromises = [this.$refs.form.validate()]
                if(Array.isArray(this.$refs.fieldForm)){
                    validatePromises.push(...this.$refs.fieldForm.map(form => form.validate()))
                } else if(this.$refs.fieldForm) {
                    validatePromises.push(this.$refs.fieldForm.validate())
                }
                await Promise.all(validatePromises)
                const data = JSON.parse(JSON.stringify(this.model))
                if(data.enableSubscription){
                    if(!data.publishTimeSpan){
                        data.publishTimeSpan=172800000
                    }
                    if(!data.loadTimeDelay){
                        data.loadTimeDelay=1800000
                    }
                    if(!data.initLoadTimeSpan){
                        data.initLoadTimeSpan=172800000
                    }
                }else{
                    Object.assign(data,{
                        titleField: null,
                        siteField: null,
                        publishTimeField: null,
                        publishTimeSpan: null,
                        loadTimeField: null,
                        loadTimeDelay: null,
                        initLoadTimeSpan: null,
                        urlField: null
                    })
                }
                data.fields = JSON.stringify(data.fields)
                if (this.model.id) {
                    datasourceConfigService.updateDatasourceConfig(data).then(() => {
                        this.dialogFormVisible = false
                        this.fetchData(this.data.number + 1)
                        this.$message({
                            type: 'success',
                            message: '修改成功!'
                        })
                    }).catch(() => {
                        this.$message({
                            type: 'error',
                            message: '修改失败!'
                        })
                    })
                } else {
                    datasourceConfigService.addDatasourceConfig(data).then(() => {
                        this.dialogFormVisible = false
                        this.fetchData(this.data.number + 1)
                        this.$message({
                            type: 'success',
                            message: '添加成功!'
                        })
                    }).catch(() => {
                        this.$message({
                            type: 'error',
                            message: '添加失败!'
                        })
                    })
                }
            },
            deleteRow(row) {
                this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    datasourceConfigService.deleteDatasourceConfig(row.id).then(() => {
                        if (this.data.content.length > 1) {
                            this.data.content.splice(this.data.content.indexOf(row), 1)
                        } else {
                            this.fetchData(this.data.number > 0 ? this.data.number : 1)
                        }
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        })
                    }).catch(() => {
                        this.$message({
                            type: 'error',
                            message: '删除失败!'
                        })
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            getTypeLabel(type){
                return this.types.find(item => item.value === type).label
            },
            addField(){
                this.model.fields.push({
                    name: null,
                    title: null,
                    type: null,
                    nullable: null,
                    multiple: null,
                    dictName: null,
                    dateFormat: null,
                    dateValueFormat: null,
                    searchable: null,
                    aggregatable: null,
                    sortable: null,
                    supportWildcast: null,
                    supportMultiValue: null,
                    highlightName: null,
                    highlightFragmentSize: null,
                    highlightFragmentNum: null,
                    fallbackField: null,
                    displayWidth: null,
                    displayGroup: null,
                    displayType: null,
                    displayInIndex: null,
                    seqNoInIndex: null,
                    displayInList: null,
                    seqNoInList: null,
                    displayInDetails: null,
                    seqNoInDetails: null
                })
            },
            moveFieldUp(index){
                if(index>0){
                    this.model.fields.splice(index-1, 0, ...this.model.fields.splice(index, 1))
                }
            },
            moveFieldDown(index){
                if(index<this.model.fields.length-1){
                    this.model.fields.splice(index+1, 0, ...this.model.fields.splice(index, 1))
                }
            },
            deleteField(index){
                this.model.fields.splice(index, 1)
            }
        }
    }
</script>
<style scoped>
    .yq-ds-field{
        border-top: 1px solid #ebebeb;
        padding-top: 15px;
    }
</style>
